import gql from 'graphql-tag';
import graphqlClient from '../helpers/graphqlClient';
import { uniqBy } from 'lodash';

export default new (class {
	async getAll() {
		const { data } = await graphqlClient.query({
			query: gql`
				{
					cmsFacilities(where: "isActive = true") {
						facility_ID
						name
						area
					}
				}
			`,

			fetchPolicy: 'no-cache'
		});

		return data.cmsFacilities;
	}

	async getUniqueAreas() {
		const { data } = await graphqlClient.query({
			query: gql`
				{
					cmsFacilities {
						name
						area
					}
				}
			`
		});

		let result = [];

		if (data.cmsFacilities.length) {
			result = uniqBy(
				data.cmsFacilities.filter(i => i.area !== ''),
				'area'
			).map(i => i.area);
		}

		return result;
	}
})();
